<template>
  <div class="ma-2">
    <v-card class="pa-3" outlined>
      <v-row class="ma-0" no-gutters>
        <v-col cols="12" sm="6">
          <div class="main-toolbar mb-4">
            <div class="icon-back">
              <v-img
                src="../../../assets/figmaIcons/white/reports.svg"
                max-width="55%"
              ></v-img>
            </div>

            <span class="main-toolbar-title">Relatórios - Dashboard</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div>
            <strong class="ml-2">Filtros:</strong>
            <v-row class="ma-0" dense align="center">
              <v-col class="d-flex align-center">
                <v-autocomplete
                  v-model="unidadeIds"
                  :items="unidades"
                  :search-input.sync="searchInput"
                  @blur="searchInput = ''"
                  item-value="id"
                  item-text="name"
                  clearable
                  chips
                  small-chips
                  multiple
                  deletable-chips
                  outlined
                  class="primary-input"
                  :label="$t('Unidade')"
                  hide-details
                  append-icon="mdi-chevron-down"
                  no-data-text="Nenhum registro"
                >
                  <template
                    v-slot:selection="{ attrs, index, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeDepartment(index)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <span class="text-caption">
                      {{ item.name }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="d-flex align-center">
                <v-autocomplete
                  v-model="departmentIds"
                  :items="localDepartments"
                  :search-input.sync="searchDepartmentInput"
                  @blur="searchDepartmentInput = ''"
                  item-value="id"
                  item-text="name"
                  clearable
                  chips
                  small-chips
                  multiple
                  deletable-chips
                  outlined
                  class="primary-input"
                  :label="$t('Setor')"
                  hide-details
                  append-icon="mdi-chevron-down"
                  no-data-text="Nenhum registro"
                >
                  <template
                    v-slot:selection="{ attrs, index, item, select, selected }"
                  >
                    <v-chip
                      v-bind="attrs"
                      :input-value="selected"
                      close
                      color="#BBCF20"
                      text-color="#fff"
                      small
                      @click="select"
                      @click:close="removeDepartment(index)"
                    >
                      {{ item.name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="{ item }">
                    <span class="text-caption">
                      {{ item.name }} / {{ item.unidade.name }}
                    </span>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col class="d-flex align-center">
                <v-btn depressed class="primary-button mr-0" @click="filtrate">
                  {{ $t('Filtrar') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <div>
      <v-row class="ma-0" no-gutters>
        <v-col cols="12" sm="3">
          <Schedule
            ref="schedule"
            :unidadeIds="unidadeIds"
            :departmentIds="departmentIds"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <Resolvability
            ref="resolvability"
            :unidadeIds="unidadeIds"
            :departmentIds="departmentIds"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <ScheduleCorrective
            ref="corrective"
            :unidadeIds="unidadeIds"
            :departmentIds="departmentIds"
          />
        </v-col>

        <v-col cols="12" sm="3">
          <Satisfaction
            ref="satisfaction"
            :unidadeIds="unidadeIds"
            :departmentIds="departmentIds"
          />
        </v-col>

        <v-col>
          <EquipStopped
            ref="equip"
            :unidadeIds="unidadeIds"
            :departmentIds="departmentIds"
          />
        </v-col>

        <v-col>
          <v-card class="pa-3" outlined style="border-radius: 6px">
            <div class="pa-2 mb-2 grey lighten-2" style="border-radius: 6px">
              <strong>{{ $t('Custos Mês Vigente') }}</strong>
            </div>
            <v-tabs color="secondary">
              <v-tab>{{ $t('Executado') }}</v-tab>
              <v-tab>{{ $t('Evitado') }}</v-tab>
              <v-tab-item>
                <ExecutedCosts
                  ref="executed"
                  :unidadeIds="unidadeIds"
                  :departmentIds="departmentIds"
                />
              </v-tab-item>
              <v-tab-item>
                <AvoidedCosts
                  ref="avoided"
                  :unidadeIds="unidadeIds"
                  :departmentIds="departmentIds"
                />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../services/ApiService'
import Resolvability from './components/resolvability.vue'
import Schedule from './components/schedule.vue'
import EquipStopped from './components/equip-stopped.vue'
import AvoidedCosts from './components/avoided-costs.vue'
import ExecutedCosts from './components/executed-costs.vue'
import ScheduleCorrective from './components/schedule-corrective.vue'
import Satisfaction from './components/satisfaction.vue'

export default {
  name: 'DashPage',

  components: {
    Resolvability,
    Schedule,
    EquipStopped,
    AvoidedCosts,
    ExecutedCosts,
    ScheduleCorrective,
    Satisfaction,
  },

  data() {
    return {
      searchDepartmentInput: '',
      searchInput2: '',
      searchInput: '',
      unidadeIds: [],
      departmentIds: [],
      unidadeLoading: false,
      departmentLoading: false,
      departments: [],
      localDepartments: [],
      unidades: [],
      institutionId: '',
      apiService: new ApiService(),
    }
  },

  created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    if (this.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    this.getDepartments()
  },

  methods: {
    filtrate() {
      if (this.$refs.resolvability) this.$refs.resolvability.list()
      if (this.$refs.schedule) this.$refs.schedule.list()
      if (this.$refs.equip) this.$refs.equip.list()
      if (this.$refs.avoided) this.$refs.avoided.list()
      if (this.$refs.executed) this.$refs.executed.list()
      if (this.$refs.corrective) this.$refs.corrective.list()
      if (this.$refs.satisfaction) this.$refs.satisfaction.list()
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.localDepartments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },
  },

  watch: {
    unidadeIds() {
      if (this.unidadeIds) {
        this.localDepartments = this.departments.filter((x) =>
          this.unidadeIds.includes(x.unidadeId)
        )
      } else {
        this.localDepartments = this.departments
      }
    },
  },
}
</script>

<style scoped></style>
